import { render, staticRenderFns } from "./Visao.vue?vue&type=template&id=b48f022c&"
import script from "./Visao.vue?vue&type=script&lang=js&"
export * from "./Visao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports